export default __webpack_public_path__ + "static/media/download.f3931934.svg";